var AccordionList = require('_components/molecules/accordion-list/accordion-list'),
  ParentAccordionList = require('_components/molecules/accordion-list/parent-accordion-list'),
  FormSelect = require('_components/atoms/form/form-select/form-select'),
  FormDropdown = require('_components/atoms/form/form-dropdown/form-dropdown'),
  FrontPageCarousel = require('_components/molecules/frontpage-campaign/frontpage-campaign'),
  RegularCourse = require('_components/molecules/course/course-row-location/course-row-location'),
  DisciplineInterests = require('_components/molecules/discipline-interests/discipline-interests'),
  BlockUnauthorized = require('_components/molecules/block/block-unauthorized/block-unauthorized'),
  ProfileEmployer = require('_components/molecules/profile/profile-employer/profile-employer'),
  ProfileHeader = require('_components/molecules/profile/profile-header/profile-header'),
  ProfileBureauSubscriptions = require('_components/molecules/profile/profile-bureau-subscriptions/profile-bureau-subscriptions'),
  ProfileBureauInsurancesChanges = require('_components/molecules/profile/profile-bureau-insurances-changes/profile-bureau-insurances-changes'),
  SearchPostalCode = require('_components/molecules/search-postal-code/search-postal-code'),
  FilterLinks = require('_components/molecules/filter-links/filter-links'),
  CourseFactsBlock = require('_components/molecules/course/course-facts-block/course-facts-block'),
  UserProfileBlock = require('_components/molecules/user-profile-block/user-profile-block'),
  Footer = require('_components/organisms/footer/footer'),
  HeaderMain = require('_components/organisms/header/header-main/header-main'),
  HeaderSub = require('_components/organisms/header/header-sub/header-sub'),
  CoursesList = require('_components/organisms/course/courses-list/courses-list'),
  CourseInstructors = require('_components/organisms/course/course-instructors/course-instructors'),
  TinyCourseList = require('_components/organisms/tiny-course-list/tiny-course-list'),
  BlockList = require('_components/organisms/block-list/block-list'),
  BlockArticle = require('_components/organisms/block-article/block-article'),
  BlockMagazine = require('_components/organisms/block-magazine/block-magazine'),
  SponsorBlock = require('_components/organisms/sponsors/sponsors-block/sponsors-block'),
  DisciplineArticleSearch = require('_components/organisms/disciplines/disciplines-article-search/disciplines-article-search'),
  CalculatorSimple = require('_components/organisms/calculator-simple/calculator-simple'),
  Calculator = require('_components/organisms/calculator/calculator'),
  FindAccountants = require('_components/organisms/find-accountants/find-accountants'),
  ProfileBureauEmployeeList = require('_components/organisms/profile/profile-bureau/profile-bureau-employee-list/profile-bureau-employee-list'),
  OverviewPage = require('_components/organisms/overview-page/overview-page'),
  SearchContent = require('_components/organisms/search-content/search-content'),
  LoginReset = require('_components/organisms/login-reset/login-reset'),
  AdminToolUserManagement = require('_components/organisms/admin-tool-user-management/admin-tool-user-management'),
  EmployeeList = require('_components/organisms/organization-employee-list/organization-employee-list'),
  RegistrationPage = require('_components/organisms/registration-page/registration-page'),
  MarketingTeaserTile = require('_components/organisms/marketing-teaser-tile/marketing-teaser-tile'),
  MyCoursesPage = require('_components/organisms/my-courses-page/my-courses-page'),
  CourseRegistrationOverview = require('_components/organisms/course-registration-overview/course-registration-overview'),
  CourseRegistrationParticipants = require('_components/organisms/course-registration-participants/course-registration-participants'),
  ReportPage = require('_components/organisms/report-page/report-page'),
  CallToAction = require('_components/organisms/call-to-action/call-to-action');

new AccordionList().init();
new ParentAccordionList().init();
new FormDropdown().init();
new FormSelect();
new FrontPageCarousel();
new RegularCourse();
new DisciplineInterests();
new BlockUnauthorized();
new ProfileEmployer();
new ProfileHeader();
new ProfileBureauSubscriptions();
new ProfileBureauInsurancesChanges();
new SearchPostalCode();
new FilterLinks();
new CourseFactsBlock();
new UserProfileBlock();
new Footer();
new HeaderMain();
new HeaderSub();
new CoursesList();
new CourseInstructors();
new TinyCourseList();
new BlockList();
new BlockArticle();
new BlockMagazine();
new SponsorBlock();
new DisciplineArticleSearch();
new CalculatorSimple();
new Calculator();
new FindAccountants();
new ProfileBureauEmployeeList();
new OverviewPage();
new SearchContent();
new LoginReset();
new AdminToolUserManagement();
new EmployeeList();
new RegistrationPage();
new MarketingTeaserTile();
new MyCoursesPage();
new CourseRegistrationOverview();
new CourseRegistrationParticipants();
new ReportPage();
new CallToAction();
